// extracted by mini-css-extract-plugin
module.exports = {"tenantBanner":"TenantInfoBanner_tenantBanner__bI-nt","value":"TenantInfoBanner_value__OVfHi"};